import { render, staticRenderFns } from "./ProductListModal.vue?vue&type=template&id=5ff6e479&scoped=true"
import script from "./ProductListModal.vue?vue&type=script&lang=js"
export * from "./ProductListModal.vue?vue&type=script&lang=js"
import style0 from "./styles/ProductListModal.css?vue&type=style&index=0&id=5ff6e479&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff6e479",
  null
  
)

export default component.exports